import * as types from "../actions/actionTypes";

// state = [] : Start out with no accounts
export default function educations(state = [], action) {
  switch (action.type) {
    case types.GET_EDUCATIONS:
      return action.educations;

    case types.CREATE_EDUCATION:
      return [...state, Object.assign({}, action.education)];

    default:
      return state;
  }
}
